module.exports = __webpack_public_path__ + "static/images/book.3afb2d154b237e83c1aa7a9a0d17ebf1.svg";